import { render, staticRenderFns } from "./ErhebungDropdown.vue?vue&type=template&id=c4aac5ae&"
import script from "./ErhebungDropdown.vue?vue&type=script&lang=ts&"
export * from "./ErhebungDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports